import styled from 'styled-components'
import { TableCol } from 'components/Table'

export default styled(TableCol)`
  color: ${props => (props.number >= 0 && (props.valid >= props.number ? '#273d56' : '#EC6C48')) || (!props.number && props.valid ? '#273d56' : '#EC6C48')} !important
`
